import React from "react";
// import { ViewDetailsHeading } from "../../../../components/ViewDetailsHeading";
import { NameAndHub } from "../NameAndHub";
import { Row, Col } from "antd";

export function ViewAddressDetails({ cpAddressDetails }) {
  return (
    <>
      {" "}
      {/* <ViewDetailsHeading text={"CP Details"} /> */}
      <div className="view-basic-details">
        <div className="view-details-header">
          <div className="view-details-header-text">CP Address</div>
        </div>
        {/* <div className="view-basic-details-contain">
        
        </div> */}
        <Row className="basic-details-view">
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Address line 1"}
                  hub={cpAddressDetails?.address1}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"City :"} hub={cpAddressDetails?.city} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Latitude"}
                  hub={cpAddressDetails?.latitude}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Address line 2 "}
                  hub={cpAddressDetails?.address2}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"State code"}
                  hub={cpAddressDetails?.stateCode}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Longitudee"}
                  hub={cpAddressDetails?.longitude}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"PIN code "}
                  hub={cpAddressDetails?.pincode}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"State name "}
                  hub={cpAddressDetails?.stateName}
                />
              </div>
            </div>
          </Col>
          {/* <Col lg={8}> */}
          {cpAddressDetails?.premiseSubBranch?.length > 0 &&
            cpAddressDetails?.premiseSubBranch?.map((e, idx) => (
              <>
                <Col lg={8} key={idx}>
                  <div className="basic-details-container">
                    <div>
                      <NameAndHub name={"Collection"} hub={e?.branchNumber} />
                    </div>
                  </div>
                </Col>
                <Col lg={8} key={idx}>
                  <div className="basic-details-container">
                    <div>
                      <NameAndHub
                        name={"Address line 1"}
                        hub={e?.addressLine1}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={8} key={idx}>
                  <div className="basic-details-container">
                    <div>
                      <NameAndHub
                        name={"Address line 2"}
                        hub={e?.addressLine2}
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={8} key={idx}>
                  <div className="basic-details-container">
                    <div>
                      <NameAndHub name={"Pincode"} hub={e?.pincode} />
                    </div>
                  </div>
                </Col>
                <Col lg={8} key={idx}>
                  <div className="basic-details-container">
                    <div>
                      <NameAndHub name={"City"} hub={e?.city} />
                    </div>
                  </div>
                </Col>
                <Col lg={8} key={idx}>
                  <div className="basic-details-container">
                    <div>
                      <NameAndHub name={"State"} hub={e?.state} />
                    </div>
                  </div>
                </Col>
                <Col lg={8} key={idx}>
                  <div className="basic-details-container">
                    <div>
                      <NameAndHub name={"State"} hub={e?.stateCode} />
                    </div>
                  </div>
                </Col>
                {/* <Col lg={8}>
                <div className="basic-details-container">
                  <div>
                    <NameAndHub
                      key={idx}
                      name={"Area name"}
                      hub={e?.addressLine1}
                      // hub={deliveryDetails.areaName1.map((item) =>
                      //   item.pincode === e.pincode
                      //     ? item?.area.areaName + ", "
                      //     : null
                      // )}
                    />
                  </div>
                </div>
              </Col> */}
                <Col lg={8}></Col>
              </>
            ))}
          {/* </Col> */}
        </Row>
      </div>
    </>
  );
}
